export default __webpack_public_path__ + "static/media/mail.32f47970.svg";